export const LIBPREFIX = 'amplitude-ts-sdk-script';
